import type { Subcategory } from '~/entities/categories'
import { getFacetOptions } from './get-facet-options'

export function getPossiblePhases({ subcategories }: { subcategories: Subcategory[] }) {
  return getFacetOptions({
    subcategories,
    selectFacet: ({ metadata }) => metadata.phase,
  })
}
